const API_BASE = process.env.VUE_APP_API_BASE_URL || '/api'

export default {
  // Endpoints
  loginEndpoint: `${API_BASE}/auth/login`,
  registerEndpoint: '/jwt/register',
  refreshEndpoint: `${API_BASE}/auth/refresh-token`,
  logoutEndpoint: `${API_BASE}/auth/logout`,

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'token',
  storageRefreshTokenKeyName: 'refreshToken',
}
